import type { Bed } from './beds'
import type { Opening, Room } from './model'
import { length } from './model'
import { bridgeWall } from './bridge-layout'
import { customGeometry, customVerticalProfile } from './custom-layout'
import { bedLocalToRoom } from './bunk-ladder-plan'

/** Omit a rear landing rail only where the actual room wall closes that edge.
 * Wall visibility is deliberately irrelevant. An opening still requires review.
 */
export function landingRearNeedsGuard(bed: Bed, room: Room, openings: Opening[], guardTop: number) {
  const landing = customGeometry(bed).landing
  if (!landing) return false
  const wall = bridgeWall(bed.rotation)
  const points = [
    bedLocalToRoom(bed, landing.x, landing.y),
    bedLocalToRoom(bed, landing.x + landing.w, landing.y),
  ]
  const along = ([x, z]: [number, number]) =>
    wall === 'A' ? x : wall === 'B' ? z : wall === 'C' ? room.width - x : room.depth - z
  const gap = ([x, z]: [number, number]) =>
    wall === 'A' ? z : wall === 'B' ? room.width - x : wall === 'C' ? room.depth - z : x
  const start = Math.min(...points.map(along)),
    end = Math.max(...points.map(along))
  if (points.some(p => Math.abs(gap(p)) > 0.01) || start < 0 || end > length(room, wall))
    return true
  return openings.some(
    o =>
      o.wall === wall &&
      o.offset < end - 0.01 &&
      o.offset + o.width > start + 0.01 &&
      o.sill < guardTop &&
      o.sill + o.height > customVerticalProfile(bed).deckHeight
  )
}
